<template>
    <div ref="content">
        <div class="menu_top_100">
            <div class="productpcbanner" :style="{backgroundImage: 'url(' + prodcutbanner + ')'}" style=""></div>
        </div>
        <div class="padding_top_66 rank_contain" ref="scrollTopList">
            <div>
                <div class="product_tab" :class="{'active':currenttap == item.type}" v-for="(item,index) in productArr" @click="tabchoose(item)">
                    <div class="product_tab_contain">
                        <img :src="item.icon" class="product_tab_img">
                    </div>
                    <div :class="{'tapactivecolor':currenttap == item.type,'smallSize': currentlang == 'eng'}">{{item.title}}</div>
                </div>
            </div>
            <div class="moretxt" @click="gorouter('/reportlist?type=rank')">{{$t('product.pc_morrlist')}}<i class="arr"></i></div>
            
            <div class="display_flex   flex-wrap_wrap">

                <div v-for="item in productdata" :class="['product_item',{'eng':currentlang == 'eng'}]" @click="toproductdetail(item)">
                    <div class="labelImg">
                        <img :src="labelarr['green']" alt="" v-if="Number(item.fishClass) == 10">
                        <img :src="labelarr['effect']" alt="" v-if="item.efficacy && item.efficacy.length > 0">
                    </div>
                    <div class="productImg" :style="{backgroundImage: 'url(' + item.img + ')'}">
                    </div>
                    <div class="padding_bottom_16">
                        <div class="limit2">{{item.prdName}}</div>
                    </div>
                    <div class="productInfo display_flex justify-content_flex-justify" v-if="currentlang !== 'eng'">
                        <span>{{$t('product.price')}}：<span class="main">{{item.price}}{{item.currency}}</span></span>
                        <span>{{$t('product.address')}}：<span class="main">{{item.originplace}}</span></span>
                    </div>
                    <div v-if="currentlang == 'eng'">
                        <div class="productInfo display_flex justify-content_flex-justify">
                            <span class="flex_1">{{$t('product.price')}}：</span>
                            <span class="flex_1">{{$t('product.address')}}：</span>
                        </div>
                        <div class="productInfo display_flex justify-content_flex-justify" style="padding-top: 8px;">
                            <span class="flex_1 main">{{item.price}}{{item.currency}}</span>
                            <span class="flex_1 main">{{item.originplace}}</span>
                        </div>
                    </div>
                </div>
                
            </div>
            <div  class="textalign_center padding_40" v-if="isLoading">
                <img src="https://p1.fishqc.net/Fho2IJV-sxzRgCKm6V_dovGJ8xIM" class="">
            </div>
            <div class="textalign_center padding_40" v-if="data_end_flag">
                <div class="moretxt" @click="gorouter('/reportlist?type=rank')">{{$t('product.pc_morrlist')}}<i class="arr"></i></div>
                <div>~ {{$t('common.bottom')}} ~</div>
            </div>
        </div>
    </div>
</template>
<style lang="scss" scoped>
@import "@/assets/css/mixin.scss";
@import "@/assets/css/main.scss";
.menu_top_100 {
    margin-top: 100px;
}

.padding_top_66 {
    padding-top: 66px;
    box-sizing: border-box;
}

.rank_contain {
    width: 1200px;
    margin: 0 auto;
}
.productpcbanner{

    height:320px;
    line-height:320px;
    font-size:50px;
    background-repeat:no-repeat;
    background-position: center;
    background-size: cover;
    // background:url('http://p1.fishqc.net/FkUbiHjQnUqiwobVWOLplU2rSiUV') center center no-repeat
}
.title {
    font-size: 24px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #A8A8AD;
    line-height: 32px;
    cursor: pointer;

    &:nth-of-type(2) {
        margin-left: 40px;
    }
}



.product_tab {
    width: 180px;
    height: 120px;
    background: #F8FBFD;
    border-radius: 60px;
    display: inline-block;
    margin-right: 24px;
    font-size: 18px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #51515C;
    cursor: pointer;
    vertical-align: middle;
    &.active {
        background-color: #DEFFF9;
    }

    .smallSize{
        padding: 0 14px;
        font-size: 14px;
        box-sizing: border-box;
    }

    &:nth-of-type(6) {
        margin-right: 0;
    }

    .product_tab_contain {
        width: 60px;
        height: 60px;
        margin: 15px auto 10px;
        position: relative;

        .product_tab_img {
            @include center;
        }
    }
}

.moretxt {
    padding: 32px 0 16px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #60DEB4;
    line-height: 20px;
    letter-spacing: 1px;
    cursor: pointer;
    display: inline-block;
    margin: 0 auto;

    .arr {
        width: 4px;
        height: 4px;
        display: inline-block;
        border-top: 1px solid #60DEB4;
        border-right: 1px solid #60DEB4;
        transform: rotate(45deg);
        vertical-align: middle;
        margin-left: 6px;
    }
}

.padding_bottom_104 {
    padding-bottom: 104px;
    box-sizing: border-box;
}

.padding_40{
    padding:40px 0;
    box-sizing: border-box;
}
</style>

<script>
import Vue from 'vue'
// @ is an alias to /src
import banner from '@/components/banner.vue'
import { myMixin } from '@/mixin/mixin.js'
import { getproductlistApi } from '@/api/api.js'
export default {
    name: '',
    components: {
        banner
    },
    mixins: [myMixin],
    data() {
        return {
            prodcutbanner:this.$t('product.pcbanner'),
            productArr: [{
                    title: this.$t('product.menu1'),
                    type: 'all',
                    icon: 'http://p1.fishqc.net/FpdcTIdDaN3eG9qH17yxwYxVBXGu',
                    iconActive: 'http://p1.fishqc.net/Fsn9dxNpktTOmlI7uQmkV1pnR5YR'
                },
                {
                    title: this.$t('product.menu2'),
                    type: 'cosmetic',
                    icon: 'http://p1.fishqc.net/Fpyj3jPDC-6NzUla8wzcV96wa8CS',
                    iconActive: 'http://p1.fishqc.net/Fk0boQaSnqMX8pzRjWifPOLK4Bek'
                },
                {
                    title: this.$t('product.menu3'),
                    type: 'motherbaby',
                    icon: 'http://p1.fishqc.net/Ft7UswRid2Lt575FyD8T3uXRlpAV',
                    iconActive: 'http://p1.fishqc.net/Fk0boQaSnqMX8pzRjWifPOLK4Bek'
                },
                {
                    title: this.$t('product.menu4'),
                    type: 'healthcare',
                    icon: 'http://p1.fishqc.net/FgJolXc83WQUrbD5OrI7fFzNgTj0',
                    iconActive: 'http://p1.fishqc.net/Fk0boQaSnqMX8pzRjWifPOLK4Bek'
                },
                {
                    title: this.$t('product.menu5'),
                    type: 'food',
                    icon: 'http://p1.fishqc.net/FuWPV77HJkySvNd4QWSd79GMPnlU',
                    iconActive: 'http://p1.fishqc.net/Fk0boQaSnqMX8pzRjWifPOLK4Bek'
                },
                {
                    title: this.$t('product.menu6'),
                    type: 'others',
                    icon: 'http://p1.fishqc.net/FjpdHZZWappd6udS6Bd69sABa4oN',
                    iconActive: 'http://p1.fishqc.net/Fk0boQaSnqMX8pzRjWifPOLK4Bek'
                }

            ],
            currenttap: 'all',
            currentpage: 1,
            productdata: [],
            isLoading:false,
            totalpage:0,
            pageSize:0,
            data_end_flag:false,
            currentlang:''
            // swiperOptions: {
            //     pagination: {
            //         el: '.swiper-pagination1'
            //     },
            //     uniqueNavElements: false,
            //     slidesPerView: 4,
            //     slidesPerGroup: 3,
            //     spaceBetween: 24,
            //     // Some Swiper option/callback...
            // },
            // swiperOptions2: {
            //     pagination: {
            //         el: '.swiper-pagination2'
            //     },
            //     uniqueNavElements: false,

            //     // Some Swiper option/callback...
            // }
        }
    },
    computed: {
        // swiper() {
        //     return this.$refs.mySwiper1.$swiper
        // }
    },
    mounted() {
        this.currentlang  = window.localStorage.getItem("LOCALE") ||  'chs'
        this.getproductlist()
        //this.$refs.scrollTopList
        window.addEventListener("scroll",this.throttle(this.handleScroll,500),true)

        // this.scroll()
    },
    beforeMount() {
      // 在页面挂载前就发起请求
      // this.currentpage = 1
      // this.getproductlist()

    },
    watch:{
        'productdata':function(){    
            this.$nextTick(function(){
                //渲染完成
                var height = this.$refs.content.offsetHeight
                this.footerAuto(height)
            })
        }
    },
    methods: {
        tabchoose(item) {
            this.currentpage = 1
            this.currenttap = item.type
            this.productdata = []
            this.totalpage = 0
            this.data_end_flag = false
            this.getproductlist()
        },
        toproductdetail(item) {
            this.$router.push({
                path: '/product/'+item.productType+'/'+item.productId
            })
        },
        getproductlist() {
            
            if(this.isLoading){
                return
            }

            if(this.data_end_flag){
                return
            }

            this.isLoading = true

            getproductlistApi({
                lang:window.localStorage.getItem("LOCALE") ||  'chs',
                type:this.currenttap,
                page: this.currentpage,
                limit: 16
            }).then(res => {
                this.isLoading = false
                if (res.code == 200) {
                    this.productdata = this.productdata.concat(res.data.list) 
                    this.totalpage = res.data.totalpage
                    if(this.currentpage >= res.data.totalpage){
                        this.data_end_flag = true;
                    }
                     
                } else {
                    this.toast(res.message)

                }
            })
        },
        handleScroll(){
            let scrollTop = document.documentElement.scrollTop || document.body.scrollTop, 
            clientHeight = document.documentElement.clientHeight || document.body.clientHeight, 
            scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight,
            height = 50; //根据项目实际定义

             // console.log('触发滚动：'+scrollTop+","+clientHeight+","+scrollHeight)
            if(scrollTop +clientHeight >= scrollHeight - height){
              if(this.currentpage > this.totalpage){
                return false
              }else{
                if(!this.isLoading){
                    this.currentpage ++ //显示条数新增
                    
                }
                
                this.getproductlist() //请求列表list 接口方法
              } 
            }else{
              return false
            }
        },
        throttle(func, wait) {
            let lastTime = null
            let timeout
            return () => {
              let context = this;
              let now = new Date();
              let arg = arguments;
              if (now - lastTime - wait > 0) {
                if (timeout) {
                  clearTimeout(timeout)
                  timeout = null
                }
                func.apply(context, arg)
                lastTime = now
              } else if (!timeout) {
                timeout = setTimeout(() => {
                  func.apply(context, arg)
                }, wait)
              }
            }
        },
        
    }
}
</script>